import { endOfDay, startOfDay } from 'date-fns'

export const setHours = (date: Date | Date[] | { from?: Date; to?: Date }) => {
  if (date instanceof Date || date instanceof Array) {
    return date
  }

  if (date?.from || date?.to) {
    return {
      from: setStartDay(date?.from),
      to: setEndDay(date?.to),
    }
  }

  return date
}

const setStartDay = (date?: Date) => {
  if (date instanceof Date) {
    return startOfDay(date)
  }

  return date
}

const setEndDay = (date?: Date) => {
  if (date instanceof Date) {
    return endOfDay(date)
  }

  return date
}
